import './Button1.scss'
import { Button } from 'primereact/button'

const Button1 = (props: {
  label: string | undefined
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean | undefined
  loading?: boolean | undefined
  class: string | undefined
}) => {
  return (
    <div className={props.class}>
      <Button
        className="w-100 justify-content-center"
        label={props.label}
        onClick={props.onClick}
        disabled={props.disabled}
        loading={props.loading}
      />
    </div>
  )
}
export default Button1
